import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../common/Constants";
import { IIndexType } from "../model/IndexType";
import IndexTypeMapper from "../service/IndexTypeMapper";
import IndexTypeParamMapper from "../service/IndexTypeParamMapper";

export default class CreateIndexTypeInteractor {
  private createResource: CreateResourceInteractor<IIndexType>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IIndexType) {
    return this.createResource.execute(
      Constants.endpointBasePath,
      IndexTypeMapper,
      IndexTypeParamMapper,
      model
    );
  }
}
